/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RoiSettings {
  startX: number;
  stopX: number;
  startY: number;
  stopY: number;
}

function createBaseRoiSettings(): RoiSettings {
  return { startX: 0, stopX: 0, startY: 0, stopY: 0 };
}

export const RoiSettings = {
  encode(message: RoiSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startX !== 0) {
      writer.uint32(13).float(message.startX);
    }
    if (message.stopX !== 0) {
      writer.uint32(21).float(message.stopX);
    }
    if (message.startY !== 0) {
      writer.uint32(29).float(message.startY);
    }
    if (message.stopY !== 0) {
      writer.uint32(37).float(message.stopY);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RoiSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoiSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.startX = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.stopX = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.startY = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.stopY = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoiSettings {
    return {
      startX: isSet(object.startX) ? globalThis.Number(object.startX) : 0,
      stopX: isSet(object.stopX) ? globalThis.Number(object.stopX) : 0,
      startY: isSet(object.startY) ? globalThis.Number(object.startY) : 0,
      stopY: isSet(object.stopY) ? globalThis.Number(object.stopY) : 0,
    };
  },

  toJSON(message: RoiSettings): unknown {
    const obj: any = {};
    if (message.startX !== 0) {
      obj.startX = message.startX;
    }
    if (message.stopX !== 0) {
      obj.stopX = message.stopX;
    }
    if (message.startY !== 0) {
      obj.startY = message.startY;
    }
    if (message.stopY !== 0) {
      obj.stopY = message.stopY;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoiSettings>, I>>(base?: I): RoiSettings {
    return RoiSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoiSettings>, I>>(object: I): RoiSettings {
    const message = createBaseRoiSettings();
    message.startX = object.startX ?? 0;
    message.stopX = object.stopX ?? 0;
    message.startY = object.startY ?? 0;
    message.stopY = object.stopY ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
